import { __awaiter, __generator } from "tslib";
import { useState } from 'react';
export default function useAwaitableComponent() {
    var _this = this;
    var _a = useState({ status: 'idle', resolve: null, reject: null }), data = _a[0], setData = _a[1];
    var handleResolve = function (val) {
        var _a;
        if (data.status !== 'awaiting')
            throw "Awaitable component is not awaiting.";
        (_a = data.resolve) === null || _a === void 0 ? void 0 : _a.call(data, val);
        setData({ status: 'resolved', resolve: null, reject: null });
    };
    var handleReject = function (err) {
        var _a;
        if (data.status !== 'awaiting')
            throw "Awaitable component is not awaiting.";
        (_a = data.reject) === null || _a === void 0 ? void 0 : _a.call(data, err);
        setData({ status: 'rejected', resolve: null, reject: null });
    };
    var handleReset = function () {
        setData({ status: 'idle', resolve: null, reject: null });
    };
    var handleExecute = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    setData({ status: 'awaiting', resolve: resolve, reject: reject });
                })];
        });
    }); };
    return [data.status, handleExecute, handleResolve, handleReject, handleReset];
}
